module.exports = __webpack_public_path__ + "static/media/yandex.90f0e1e3.svg";